import { getStringFromLocalStorage } from "modules/apnaLearn/utils/helpers";
import Clevertap from "libs/Clevertap";
import { isUserLoggedIn } from "utils";
import { trackAnalyticsEvent } from "utils/app-bridge";
import Mixpanel from "utils/Mixpanel";
import { LEARN_USER_DATA } from "modules/apnaLearn/utils/constants";
import { LOCAL_STORAGE_KEYS } from "utils/constants";

export const MOCK_INTERVIEW_EVENTS = {
	// Video events
	WATCH_DEMO_CLICKED: "Job Prep Watch Demo Clicked",
	VIDEO_SHOWN: "Job Prep Video Shown",
	VIDEO_PLAY_BUTTON_CLICKED: "Job Prep Video Play Button Clicked",
	VIDEO_MODAL_CLOSED: "Job Prep Video Modal Closed",
	// Job prep page view
	JOB_PREP_PAGE_VIEW: "Job Prep Page View",
	JOB_PREP_CARD_CLICKED: "Job Prep Card Clicked",
	JOB_PREP_CARD_IMPRESSION: "Job Prep Card Impression",
	SHARE_BUTTON_CLICKED: "Share Button Clicked",
	SEARCH_COMPANY_DROPDOWN_CLICKED: "Search Company Dropdown Clicked",
	SEARCH_COMPANY_DROPDOWN_SELECTED: "Search Company Dropdown Selected",
	SEARCH_ROLE_DROPDOWN_CLICKED: "Search Role Dropdown Clicked",
	SEARCH_ROLE_DROPDOWN_SELECTED: "Search Role Dropdown Selected",
	INTERVIEW_HISTORY_CLICKED: "Interview History Clicked",

	// Mock interview page view
	MOCK_INTERVIEW_PAGE_VIEW: "Mock Interview Page View",

	// Profile events
	UPDATE_PROFILE_SCREEN_SHOWN: "Update Profile Screen Shown",
	UPDATE_PROFILE_CLICKED: "Update Profile Clicked",
	CONTINUE_CLICKED: "Continue Clicked",
	UPDATE_PROFILE_SCREEN_CLOSED: "Update Profile Screen Closed",

	// Additional information events
	ADDITIONAL_INFO_SCREEN_SHOWN: "Provide Additional Information Screen Shown",
	RESUME_UPLOADED_SUCCESS: "Resume Uploaded Successfully",
	ADDITIONAL_INFO_CONTINUE_CLICKED: "Additional Info Continue Clicked",
	ADDITIONAL_INFO_SKIP_CLICKED: "Additional Info Skip Clicked",
	ADDITIONAL_INFO_SCREEN_CLOSED: "Provide Additional Information Screen Closed",

	// Interview events
	INTERVIEW_START_BUTTON_CLICKED: "start interview clicked",
	INTERVIEW_LOADING_SCREEN_SHOWN: "interview loading screen shown",
	INTERVIEW_STARTS: "Interview Starts",
	INTERVIEW_SCREEN_SHOWN: "Interview Screen Shown",
	BOT_CALL_CONTROLS_CLICKED: "Bot Call Controls Clicked",
	INTERVIEW_COMPLETION_SCREEN_SHOWN: "Interview Completion Screen Shown",
	INTERVIEW_ENDS: "Interview Ends",
	GO_TO_COMPLETED_PREPS: "Go to completed prep click",
	EXPLORE_OTHER_PREPS: "Explore other prep click",

	// Feedback events
	INTERVIEW_FEEDBACK_REPORT_PAGE_VIEW: "Interview Feedback Report Page View",
	SHARE_REPORT_CLICKED: "Share Your Report Clicked",
	DOWNLOAD_CHEATSHEET_CLICKED: "Download Personalised Cheatsheet Clicked",
	FEEDBACK_POPUP_SHOWN: "Feedback Popup Shown",
	INTERVIEW_FEEDBACK_RESPONSE: "Feedback Response",
	// History events
	HISTORY_PAGE_VIEW: "History Page View",
	HISTORY_INTERVIEW_CARD_CLICKED: "History Interview Card Clicked",
};

export interface TrackingData {
	source?: string;
	userId?: string;
	interviewId?: string;
	interviewType?: string;
	interviewerName?: string;
	role_name?: string;
	company_name?: string;
	sessionId?: string;
	[key: string]: any;
}

/**
 * Track mock interview events using both Mixpanel and app-bridge
 *
 * @param eventName The name of the event to track
 * @param trackingData Additional tracking data to include
 */
export const trackMockInterviewEvent = (
	eventName: string,
	trackingData: TrackingData = {},
	trackCleverTapTitle?: string // option param to track clever tap events
) => {
	try {
		// Tracking data with source
		const eventData = {
			...trackingData,
			source: trackingData.source || "Mock Interview Web",
		};

		// Retrieve user data from session and local storage
		const appUserDataString = sessionStorage.getItem(LEARN_USER_DATA);
		const loggedInUserDataString = getStringFromLocalStorage(LOCAL_STORAGE_KEYS.USER);

		let appUserData = null;
		let loggedInUserData = null;

		// Track with Mixpanel
		// if(appUserData?.id) // only trigger for app
		trackAnalyticsEvent(eventName, eventData, ["MIXPANEL"]);
		Mixpanel.track(eventName, eventData);

		try {
			if (appUserDataString) appUserData = JSON.parse(appUserDataString);
			if (loggedInUserDataString)
				loggedInUserData = JSON.parse(loggedInUserDataString);
		} catch (error) {
			console.error("Error parsing user data:", error);
		}

		if (trackCleverTapTitle) {
			// Track with app-bridge (for mobile)
			if (appUserData?.id) {
				trackAnalyticsEvent(trackCleverTapTitle, eventData, ["CLEVERTAP"]);
			}

			if (loggedInUserData?.id) {
				Clevertap.trackEvent(trackCleverTapTitle, {
					...eventData,
					WEB_EVENT_DEV_TEST: "Desktop/Mweb",
				});
			}
		}
	} catch (error) {
		console.error(`Error tracking event ${eventName}:`, error);
	}
};

// Export both the tracking function and events
export default {
	trackMockInterviewEvent,
	MOCK_INTERVIEW_EVENTS,
};
